import { TextField } from "@mui/material";

function TextInput(props) {
  return <TextField {...props} fullWidth size="small" style={{marginBottom: props.noMargin ? 0 : '15px'}} />
}

export default TextInput;